<template>
  <div class="d-flex justify-center" :style="{ padding: '10px', width: '90%' }">
    <div
      class="d-flex pa-2 flex-column"
      :style="{
        'margin-bottom': '40px',
        width: '90%',
        'min-height': '550px',
        height: 'min-content',
      }"
    >
      <promo-header
        :done="done"
        :step="step"
        :validateStep1="validateStep1"
        :validateStep2="validateStep2"
      />

      <v-stepper
        class="d-flex pa-2 flex-column"
        v-model="step"
        :style="{ 'margin-bottom': '40px' }"
        elevation="2"
        v-if="!loadingAutofill"
      >
        <v-stepper-items>
          <v-stepper-content step="1">
            <promo-step-1 />
          </v-stepper-content>
          <v-stepper-content step="2">
            <promo-step-2 />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  components: {
    PromoHeader: () => import('../../components/steper/promo/PromoHeader.vue'),
    PromoStep1: () => import('../../components/steper/promo/PromoStep1.vue'),
    PromoStep2: () => import('../../components/steper/promo/PromoStep2.vue'),
  },
  data() {
    return {
      done: false,
      loadingAutofill: false,
      validateStep1: true,
      validateStep2: true,
    };
  },
  beforeMount() {
    this.$store.commit('promo/setFinishStep', false);

    if (this.$route.params.id) this.editItem(this.$route.params.id);
  },
  computed: {
    step() {
      return this.$store.state.promo.step;
    },
    finishStep() {
      return this.$store.state.promo.finishStep;
    },
    bulkUploadStatus() {
      return this.$store.state.promo.data.bulk_upload_status;
    },
    bulkId() {
      return this.$store.state.promo.data.bulk_id;
    },
    loading() {
      return this.$store.state.promo.loading;
    },
    detailData() {
      return this.$store.state.promo.item;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.step <= 2 && !this.finishStep) {
      const answer = window.confirm(
        'Do you really want to leave? you have unsaved changes!'
      );
      if (answer) {
        if (this.bulkUploadStatus) this.deleteBulk(this.bulkId);
        this.$store.commit('promo/clearDataStep');
        this.$store.commit('promo/clearDataVariable');
        next();
      } else {
        next(false);
      }
    } else {
      this.$store.commit('promo/clearDataStep');
      this.$store.commit('promo/clearDataVariable');
      this.$store.commit('promo/setStep', 1);
      next();
    }
  },
  methods: {
    async deleteBulk(bulkId) {
      await this.$store
        .dispatch('promo/bulkDelete', {
          date,
          bulkId,
        })
        .then(() => {});
    },

    convertDate(dateVal) {
      const newdate = dateVal.split('-').reverse().join('-');
      return newdate;
    },

    async editItem(itemId) {
      await this.$store
        .dispatch('promo/getDetail', {
          id: itemId,
          date,
        })
        .then(() => {
          if (!this.loading && this.detailData != null) {
            const newPromo = {
              id: this.detailData.id,
              old_promo_type: this.detailData.promo_type,
              promo_type: 2,
              merchants: [],
              bulk_id: '',

              promo_name: this.detailData.promo_name,
              qr_method_npm: parseInt(this.detailData.qr_method_npm, 10),
              qr_method_cpm: parseInt(this.detailData.qr_method_cpm, 10),
              payment_type_on_us: parseInt(
                this.detailData.payment_type_on_us,
                10
              ),
              payment_type_off_us: parseInt(
                this.detailData.payment_type_off_us,
                10
              ),
              min_transaction: this.detailData.min_transaction_decimal,
              promo_period: [
                this.convertDate(this.detailData.start_datetime),
                this.convertDate(this.detailData.end_datetime),
              ],
              promo_quota_per_merchant:
                this.detailData.promo_quota_per_merchant,
              promo_quota_per_customer:
                this.detailData.promo_quota_per_customer,
              promo_quota_merchant_per_day:
                this.detailData.promo_quota_merchant_per_day,
              promo_quota_customer_per_day:
                this.detailData.promo_quota_customer_per_day,
              jenis_promo: parseInt(this.detailData.jenis_promo, 10),
              discount_type: parseInt(this.detailData.discount_type, 10),
              percent: this.detailData.percent,
              max_discount_amount: this.detailData.max_discount_amount_decimal,
              fix_amount: this.detailData.fix_amount_decimal,
              syarat_dan_ketentuan: this.detailData.syarat_dan_ketentuan,
              bulk_upload_status: false,
              status: this.detailData.status == 'Active' ? 1 : 0,
              disabled_form: this.detailData.disabled_form,
              disabled_edit: this.detailData.disabled_edit,
            };

            this.$store.commit('promo/setDataPromo', newPromo);
          }
        });
    },
  },
};
</script>
